
import Vue from "vue";
import Crm from "@/models/crm/crm";
import CrmHistory, { CrmHistoryEventType } from "@/models/crm/crm-history";
import { CrmHistoryAwsDocument } from "@/models/base/crm-history-aws-document";
import { AWSFileService } from "@/services/aws-file-service";
import { CrmService } from "@/services/crm-service";
import { createConfirmBuilder } from "@/setup/confirm-builder";

interface DocEntry {
	doc: CrmHistoryAwsDocument;
	timestamp: string;
	history: CrmHistory;
}

export default Vue.extend({
	props: {
		crm: {
			required: true,
			type: Object as () => Crm
		}
	},
	computed: {
		documents(): DocEntry[] {
			let result: DocEntry[] = [];
			for (let h of this.crm.History as CrmHistory[]) {
				if (!h.AWSDocuments?.length) continue;
				for (let doc of h.AWSDocuments) {
					result.push({doc, timestamp: h.getTimeStampString(), history: h});
				}
			}
			result.sort((a, b) => b.history.ID - a.history.ID);
			return result;
		}
	},
	methods: {
		preview(doc: CrmHistoryAwsDocument) {
			if (!doc.File) return;
			AWSFileService.previewAwsFile(doc.File);
		},
		async download(doc: CrmHistoryAwsDocument) {
			if (!doc.File) return;
			await AWSFileService.downloadFile(doc.File.Token, doc.File.Name);
		},
		async remove(entry: DocEntry) {
			let confirmBuilder = createConfirmBuilder.bind(this)();
			confirmBuilder.setMessage(this.$ct("confirm-delete-document"));
			confirmBuilder.setWarningTitle();
			let confirm = await confirmBuilder.show();
			if (!confirm) return;
			await CrmService.deleteCrmHistoryDocument(entry.history.ID, entry.doc);
			let history = entry.history;
			let index = history.AWSDocuments.indexOf(entry.doc);
			if (index >= 0) history.AWSDocuments.splice(index, 1);
			if (history.EventTypeID === CrmHistoryEventType.File && history.AWSDocuments.length === 0) {
				await CrmService.deleteCrmHistory(history.ID);
				let h = this.crm.History as CrmHistory[];
				let hIndex = h.indexOf(history);
				if (hIndex >= 0) h.splice(hIndex, 1);
			}
		},
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
